import { render, staticRenderFns } from "./CampanhaVendaMargemGerenteTabela.vue?vue&type=template&id=d8fbeb10&scoped=true"
import script from "./CampanhaVendaMargemGerenteTabela.vue?vue&type=script&lang=js"
export * from "./CampanhaVendaMargemGerenteTabela.vue?vue&type=script&lang=js"
import style0 from "./CampanhaVendaMargemGerenteTabela.vue?vue&type=style&index=0&id=d8fbeb10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fbeb10",
  null
  
)

export default component.exports